<div class="color-customizer bm--scroll-bar" [ngClass]="{ 'color-customizer--active': isSettingsShow }">
  <div class="color-customizer__top">
    <!-- Header block-->
    <div class="color-customizer__header">
      <p class="color-customizer__header-title">{{ lg.colorCustomizer.designPage }}</p>
      <!-- <button (click)="resetSettings()">reset settings</button> -->
      <div class="btv-icon-close" (click)="closeSettings()"></div>
    </div>

    <!-- Theme block-->
    <div class="color-customizer__theme-block">
      <div class="color-customizer__theme-select">
        <mat-form-field appearance="outline" bmTheme="color-customizer">
          <mat-label>{{ lg.colorCustomizer.themeSelect.title }}</mat-label>
          <mat-select [(value)]="currenThemeTitle" (selectionChange)="changeTheme()">
            @for (th of colorThemes; track th) {
              <mat-option [value]="th.title">
                {{ th.descr }}
              </mat-option>
            }
            @if (currenThemeTitle === 'custom') {
              <mat-option [value]="'custom'">
                {{ lg.colorCustomizer.themeSelect.themes.custom }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      <div class="color-customizer__btn-box">
        <bmcore-button
          title="{{ lg.button.save }}"
          (clickHandler)="saveSettings()"
          [styleName]="'color customizer'"
          [disabled]="disableSaveSettingsBtn"
        >
        </bmcore-button>
      </div>
    </div>
  </div>

  <!-- Settings -->
  <div class="color-customizer__content">
    @if (appType === 'PROD-PAGE') {
      @for (group of manageGroups; track group) {
        <bmcore-manage-block
          (click)="changeCurrentGroup($event, group.title)"
          (updateContactsEvent)="updateContactsLocally($event)"
          [currentGroupTitle]="currentGroupTitle"
          [group]="group"
          [groups]="manageGroups"
          [socContacts]="socContacts"
          [contactsResultMessage]="contactsResultMessage"
        >
        </bmcore-manage-block>
      }
    }

    <!-- Color groups block -->
    @for (group of groups; track group) {
      @if (group?.app?.includes(appType)) {
        <bmcore-color-block
          (click)="changeCurrentGroup($event, group.title)"
          [group]="group"
          [groups]="groups"
          [currentGroupTitle]="currentGroupTitle"
          (changeThemeEvent)="changeTitleTheme($event)"
          [appType]="appType"
        >
        </bmcore-color-block>
      }
    }
  </div>
</div>
